import Container from '@material-ui/core/Container';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import Card from '../../../../components/Auth/Card';
import BackToLogin from '../../../../components/Auth/BackToLogin';
import { Mailbox } from '../../../../assets/images';
import useAuthStyles from '../../../../styles/pages/auth';

const useStyles = makeStyles<Theme>((theme) =>
  createStyles({
    container: {
      padding: '0',
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    cardContainer: {
      '&&': {
        minHeight: 310,
        justifyContent: 'center',
      },
    },
  })
);


const PwdSended = () => {
  const classes = useStyles();
  const authClasses = useAuthStyles();

  return (
    <Container maxWidth="sm">
      <Grid
        container
        className={[authClasses.container, classes.container].join(' ')}
      >
        <Card className={classes.cardContainer}>
          <CardContent>
            <Grid container justify="center">
              <img src={Mailbox} alt="mail-box" />
            </Grid>
            <Grid item xs={12} className={authClasses.descriptionContainer}>
              <Typography variant="h1">Senha alterada com sucesso.</Typography>
              <Typography>
              Retorne para a tela de login e acesse o portal com a sua nova senha. 
              </Typography>
            </Grid>
          </CardContent>
        </Card>
        <BackToLogin />
      </Grid>
    </Container>
  );
};

export default PwdSended;

